export default __webpack_public_path__ + "static/media/Group 277.6763c69a.svg";